import { MODE_DEV, MODE_PROD } from 'root/settings'
import { getSchema } from '../utils'

export const PHOTOS = (() => {
    return getSchema({
        [MODE_DEV]: Object.freeze({
            url: 'url'
        }),
        [MODE_PROD]: Object.freeze({
            url: 'u'
        })
    })
})()

export const PRODUCT_DETAILS = (() => {
    return getSchema({
        [MODE_DEV]: Object.freeze({
            about: 'about',
            effects: 'effects',
            photos: 'photos'
        }),
        [MODE_PROD]: Object.freeze({
            about: 'a',
            effects: 'e',
            photos: 'p'
        })
    })
})()
